import React from "react";
import { Link } from "react-router-dom";
import { Box, Button, Divider, Menu, MenuButton, MenuItem, MenuList, Stack, Switch } from "@chakra-ui/react";

import { signOut } from "firebase/auth";
import { auth } from "./firebaseConfig";
import { useLanguage } from "./languageContext";
import LanguageSwitch from "./LanguageSwitch";
import { HamburgerIcon } from "@chakra-ui/icons";
import { IconButton } from "@chakra-ui/react";


const handleSignOut = async () => {
  try {
    // Sign out from Firebase authentication
    await signOut(auth);
    // Navigate to the login page
    window.location.href = "/";
  } catch (error) {
    console.log("Error signing out:", error);
  }
};

const NavBar = () => {
  const { language, toggleLanguage } = useLanguage();
  return (
    <>
      <Stack
        // direction={{ base: "column", md: "row" }}
        direction="row"
        spacing={4}
        padding={4}
        display="flex"
        alignItems={{base:"center", md:"center"}}
        flexWrap="wrap"
        justifyContent={"space-between"}
        backdropBlur={"lg"}
        backdropFilter={"blur(5px)"}
        // bg="white"
        // justify={"center"}
      >
        <Box display={{ base: "none", md: "block" }}>
          <Stack
            direction="row"
            pl={{ base: "0%", md:"15%", lg:"25%"}}
            spacing={{base: 5, md:10, lg: 40}}
            justifyContent="space-evenly"
            align="left"
          >
            <Button
              as={Link}
              to="/flora"
              colorScheme="teal"
              color="white"
              variant="link"
              size="sm"
            >
              {language === "english" ? "Upload Data" : "Subir Datos"}
            </Button>
            <Button
              as={Link}
              to="/edit/flora"
              colorScheme="teal"
              color="white"
              variant="link"
              size="sm"
            >
              {language === "english" ? "View/Edit Data" : "Ver/Editar Datos"}
            </Button>
            <Button
              as={Link}
              to="/Dashboard1"
              colorScheme="teal"
              color="white"
              variant="link"
              size="sm"
            >
              {language === "english" ? "Dashboard" : "Tablero"}
            </Button>
            <Button
              as={Link}
              to="/AddUser"
              colorScheme="teal"
              color="white"
              variant="link"
              size="sm"
            >
              {language === "english" ? "Add User" : "Agregar Usuario"}
            </Button>
          </Stack>
        </Box>
        <Box display={{ base: "block", md: "none" }}>
          <Menu>
            <MenuButton as={IconButton} icon={<HamburgerIcon />} variant="solid" colorScheme="green"
            color="white" />
            <MenuList>
              <MenuItem as={Link} to="/flora">
                {language === "english" ? "Upload Data" : "Subir Datos"}
              </MenuItem>
              <MenuItem as={Link} to="/edit/flora">
                {language === "english" ? "Edit Data" : "Editar Datos"}
              </MenuItem>
              <MenuItem as={Link} to="/Dashboard1">
                {language === "english" ? "Dashboard" : "Tablero"}
              </MenuItem>
              <MenuItem as={Link} to="/AddUser">
                {language === "english" ? "Add User" : "Agregar Usuario"}
              </MenuItem>
            </MenuList>
          </Menu>
        </Box>

        <Stack
          direction={"row"}
          spacing={4}
          alignContent="center"
          alignItems="center"
          float="right"
        >
          <LanguageSwitch language={language} toggleLanguage={toggleLanguage} />

          <Button
            colorScheme="white"
            variant="outline"
            onClick={handleSignOut}
            size={{ base: "sm" }}
            width="120px"
          >
            {language === "english" ? "Sign Out" : "Cerrar Sesión"}
          </Button>
        </Stack>

        <Divider />
      </Stack>
    </>
  );
};

export default NavBar;
